import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import StatutsService from "../statuts/StatutsService";
import AnneesacademiquesService from "./AnneesacademiquesService";


export default function AnneesacademiquesIndex() {
    const activeLink = "ANNEES ACADEMIQUES"
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)
    const token = useSelector(state => state.auth.token)
    const [anneesacademiques, setAnneesacademiques] = useState([])
    const [statuts, setStatuts] = useState([])
    const [errors, setErrors] = useState({});
    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const [addFormData, setAddFormData] = useState({
        anneedebutAnneeacademique: '',
        anneefinAnneeacademique: '',
        descriptionAnneeacademique: '',
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        anneedebutAnneeacademique: '',
        anneefinAnneeacademique: '',
        descriptionAnneeacademique: '',
        statutId: '',
        id: ''
    });

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        anneedebutAnneeacademique: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("annee_debut"),

        anneefinAnneeacademique: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("annee_fin"),

        descriptionAnneeacademique: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("description")
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        anneedebutAnneeacademique: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("annee_debut"),

        anneefinAnneeacademique: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("annee_fin"),

        descriptionAnneeacademique: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        statutId: Joi.number().required("").empty('').options({
            language: {
              any: { required: 'le champ est obligatoire' },
            },
          }).label("Statut"),

        id: Joi.number().min(1).empty('').options({
            language: {
                string: { min: "minimum 1" },
            },
        }).label("Id")
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            anneedebutAnneeacademique: '',
            anneefinAnneeacademique: '',
            descriptionAnneeacademique: '',
        });
    };


    //get liste Annees académiques
    const fetchAnnesacademiques = async () => {
        await AnneesacademiquesService.index(token).then((res) => {
            //console.log(res.data.data)
            setAnneesacademiques(res.data.data.anneesacademiques)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //get liste statuts
    const fetchStatuts = async () => {
        await StatutsService.index(token).then((res) => {
            setStatuts(res.data.data.statuts)
        }).catch(error => {
            console.log(error)
        })
    }
    //redirection sur la page edit sans afficher les id dans l'url
    /* const goToEdit = (param) => {
         navigate(myroutes.anneesacademiques_edit, { state: { id: param } })
     }*/

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                AnneesacademiquesService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchAnnesacademiques()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData({ ...editFormData, [name]: value });
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Enregistrer un nouveau types contrats
    const handleStore = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await AnneesacademiquesService.store(addFormData, token).then(response => {
                //Fermer le modal
                setIsVisible(false)
                //Vider les champs du formulaire
                clearForm()
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des anneesacademiques
                    fetchAnnesacademiques()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'ajout de genre
    const addModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleStore}>
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-6">
                    <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Début année académique <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-anneedebutAnneeacademique"
                    type="text"
                    value={addFormData.anneedebutAnneeacademique}
                    onChange={handleChange}
                    placeholder="Exemple : 2023"
                    required={true}
                    name="anneedebutAnneeacademique"
                />

                {errors.anneedebutAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.anneedebutAnneeacademique}
                    </div>
                )}
                    </div>
                    <div className="col-md-6">
                    <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Fin année académique <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-anneefinAnneeacademique"
                    type="text"
                    value={addFormData.anneefinAnneeacademique}
                    onChange={handleChange}
                    placeholder="Exemple : 2024"
                    required={true}
                    name="anneefinAnneeacademique"
                />

                {errors.anneefinAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.anneefinAnneeacademique}
                    </div>
                )}
                    </div>
                </div>
                
            </div>

            <div className="col-md-12 mb-2">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionAnneeacademique" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionAnneeacademique"
                    onChange={handleChange}
                    name="descriptionAnneeacademique"
                    rows="3"
                    value={addFormData.descriptionAnneeacademique}
                ></textarea>

                {errors.descriptionAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.descriptionAnneeacademique}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await AnneesacademiquesService.show(id, token).then((response) => {
            const data = response.data.data;
            //console.log(response.data.data)
            setEditFormData({
                anneedebutAnneeacademique: data.anneedebutAnneeacademique,
                anneefinAnneeacademique: data.anneefinAnneeacademique,
                descriptionAnneeacademique: data.descriptionAnneeacademique,
                statutId: data.statuts.id,
                id: id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //Modification d'un Anneeacademique
    const handleUpdate = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await AnneesacademiquesService.update(editFormData, token).then(response => {

                //Fermer le modal
                setEditModal(false)
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des types contrats
                    fetchAnnesacademiques()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                //Fermer le modal
                setEditModal(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'edition de Anneeacademique
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
             <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-6">
                    <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Début année académique <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-anneedebutAnneeacademique"
                    type="text"
                    value={editFormData.anneedebutAnneeacademique}
                    onChange={handleChange}
                    placeholder="Exemple : 2023"
                    required={true}
                    name="anneedebutAnneeacademique"
                />

                {errors.anneedebutAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.anneedebutAnneeacademique}
                    </div>
                )}
                    </div>
                    <div className="col-md-6">
                    <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Fin année académique <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-anneefinAnneeacademique"
                    type="text"
                    value={editFormData.anneefinAnneeacademique}
                    onChange={handleChange}
                    placeholder="Exemple : 2024"
                    required={true}
                    name="anneefinAnneeacademique"
                />

                {errors.anneefinAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.anneefinAnneeacademique}
                    </div>
                )}
                    </div>
                </div>
                
            </div>
            <div className="row">
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Statuts <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="statutId" id="bs-validation-statutId" value={editFormData.statutId} onChange={handleEditChange} required>
                        <option value="" disabled selected>Sélectionnez une valeur</option>
                        {statuts.length > 0 && statuts.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleStatut}</option>
                        ))}
                    </Form.Select>

                    {errors.statutId && (
                        <div className="alert alert-danger">
                            {errors.statutId}
                        </div>
                    )}

                </div>
            </div>

            <div className="row mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionAnneeacademique" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionAnneeacademique"
                    onChange={handleEditChange}
                    name="descriptionAnneeacademique"
                    rows="3"
                    value={editFormData.descriptionAnneeacademique}
                ></textarea>

                {errors.descriptionAnneeacademique && (
                    <div className="alert alert-danger">
                        {errors.descriptionAnneeacademique}
                    </div>
                )}

            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );


    useEffect(() => {
        fetchAnnesacademiques();
        fetchStatuts()
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-2">
                    <h5 className="card-header">Liste des années académiques disponibles &nbsp;&nbsp;
                        <Button className="rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
                            <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter une année</Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Année académique</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Statuts</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {anneesacademiques.length > 0 && anneesacademiques.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.anneedebutAnneeacademique + ' - ' + item.anneefinAnneeacademique}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.descriptionAnneeacademique}</span></td>
                                        <td className="cell">
                                            <span className={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}

                {/* Modal Ajout des anneesacademiques*/}
                <CustomAddModal
                    modalTitle="Enregistrement année académique"
                    modalContent={addModalContent}
                    visible={isVisible}
                    close={() => setIsVisible(false)}
                />

                {/**End Modal Ajout des anneesacademiques*/}

                {/* Modal Edition des anneesacademiques*/}
                <CustomEditModal
                    modalTitle="Modification Annees Academiques"
                    modalContent={editModalContent}
                    visible={editModal}
                    close={() => setEditModal(false)}
                />

                {/**End Modal Edition des types contrats*/}

            </div>

        </Layout>
    )
}